<section class="login-page">
  <div class="login-shell" role="main">
    <div class="login-hero">
      <div class="brand">
        <img class="logo" src="assets/masterteam_sa_logo.jpeg" alt="Masterteam SA" />
        <div class="brand-text">
          <div class="brand-name">IdeasHub</div>
          <div class="brand-tag">Turn ideas into action</div>
        </div>
      </div>

      <h1 class="headline">Sign in to your workspace</h1>
      <p class="lead">Use your {{ allowedDomain }} Google Workspace account to continue.</p>

      <ul class="value-props">
        <li>Capture ideas quickly</li>
        <li>Collaborate with your team</li>
        <li>Keep everything searchable</li>
      </ul>

      <p class="fine-print">Secure sign-in powered by Google.</p>
    </div>

    <div class="login-card" aria-label="Sign in">
      <div class="card-header">
        <h2>Continue with Google</h2>
        <p class="subtitle">Only {{ allowedDomain }} accounts are allowed.</p>
      </div>

      <div class="google-button-wrapper" [class.disabled]="loading">
        <div #googleButtonHost class="google-button-host"></div>
      </div>

      <div class="status">
        <p class="loading-message" *ngIf="loading">
          <span class="spinner" aria-hidden="true"></span>
          Signing you in...
        </p>
        <p class="error-message" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>
      </div>

      <p class="footer-note">Having trouble? Refresh and try again.</p>
    </div>
  </div>
</section>
